import React, { useEffect, useState } from 'react';
import { Spinner, Alert } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { tryParseJson } from '../../utilities/tryParseJson';
import { useAuth } from "react-oidc-context";

const InviteInfoPage = () => {
    const { search } = useLocation();
    const navigate = useNavigate();
    const inviteCode = new URLSearchParams(search).get('inviteCode');
    const [invite, setInvite] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const auth = useAuth();
    useEffect(() => {
        const fetchInvite = async () => {
            try {
                const res = await axios.get(`/api/invites/code?sharedCode=${inviteCode}`);
                setInvite(res.data);
            } catch (err) {
                console.error(err);
                setError('Unable to retrieve invite information. It may be invalid or expired.');
            } finally {
                setLoading(false);
            }
        };

        fetchInvite();
    }, [inviteCode]);
    useEffect(() => {
        if (invite) {
            const { success, data, error } = tryParseJson(invite?.payload);
            if (success) {
                const stateObj = {
                    inviteId: invite.inviteId,
                    placeHolderAccountId: data.placeHolderAccountId,
                    sharedCode: inviteCode
                };
                const redirect_uri = window.location.href.replace(/\/invite.*$/, '/ProcessInvite');
                const authParams = {
                    acr_values: `brand:dcg partner_invite:true`,
                    login_hint: data.email,
                    redirect_uri: redirect_uri,
                    state: encodeURIComponent(JSON.stringify(stateObj))
                };
                if (auth?.isAuthenticated && auth?.user?.access_token && auth?.user?.profile?.sub) {
                    navigate("/");
                } else {
                    auth.signinRedirect(authParams);
                }
            } else {
                console.error('Invalid JSON:', error.message);
                setError('invalid JSON');
            }
        }

    }, [invite, auth, navigate, inviteCode]);

    if (loading) {
        return (
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '200px' }}>
                <Spinner className="mb-3" />
                <div>Processing your invite...</div>
            </div>
        );
    }

    if (error) {
        return <Alert color="danger">{error}</Alert>;
    }

    return (
        <div className="container mt-4">
            <h4>Invite Details</h4>
        </div>
    );
};

export default InviteInfoPage;
